import { Navigate, useRoutes } from "react-router-dom";

import ProtectedRoute from "components/ProtectedRoute";
import Dashboard from "layout/commanLayout";
import OnboardingPage from "screens/OnboardingPage";
import LayoutContent from "layout/layoutContent";
import MyAdminClientsList from "screens/Admin/ClientsList";
import OwnerDetail from "screens/Admin/OwnerDetail";
import CoachesList from "screens/Coaches/CoachesList";
import CreateNutritionPage from "screens/CreateNutritionPage";
import CreateProgramPage from "screens/CreateProgramPage";
import EditExercice from "screens/EditExercice";
import EditNutrition from "screens/EditNutrition";
import EditProgramPage from "screens/EditProgramPage";
import HomePage from "screens/HomePage";
import ClientDetails from "screens/MyClients/ClientDetails";
import MyClientsList from "screens/MyClients/ClientsList";
import NutritionInfo from "screens/NutritionInfo";
import NutritionPage from "screens/NutritionPage";
import NutritionPlans from "screens/NutritionPlans";
import ProgrammsPage from "screens/ProgrammsPage";
import CreateSession from "screens/Session/CreateSession";
import SessionList from "screens/Session/SessionList";
import Settings from "screens/Settings";
import TutorialsPage from "screens/Tutorials";
import PersonalizationPage from "screens/Personalization";
import Welcome from "screens/Welcome";
import AuthPage from "screens/auth";

const Routes = () => {
  const routes = [
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "fitness/exercices",
          element: <LayoutContent element={HomePage} />,
        },
        {
          path: "fitness/exercices/new",
          element: <LayoutContent element={EditExercice} />,
        },
        {
          path: "fitness/exercices/:id",
          element: <LayoutContent element={EditExercice} />,
        },

        {
          path: "nutrition/recipes",
          element: <LayoutContent element={NutritionPage} />,
        },
        {
          path: "nutrition/recipes/create",
          element: <LayoutContent element={EditNutrition} />,
        },
        {
          path: "nutrition/recipes/:id",
          element: <LayoutContent element={EditNutrition} />,
        },

        {
          path: "nutrition/programs",
          element: <LayoutContent element={NutritionPlans} />,
        },
        {
          path: "nutrition/programs/create",
          element: <LayoutContent element={CreateNutritionPage} />,
        },
        {
          path: "nutrition/programs/final",
          element: <LayoutContent element={NutritionInfo} />,
        },
        {
          path: "nutrition/programs/:id",
          element: <LayoutContent element={CreateNutritionPage} />,
        },
        {
          path: "nutrition/programs/final/:id",
          element: <LayoutContent element={NutritionInfo} />,
        },

        {
          path: "fitness/programs",
          element: <LayoutContent element={ProgrammsPage} />,
        },
        {
          path: "fitness/programs/create",
          element: <LayoutContent element={EditProgramPage} />,
        },
        {
          path: "fitness/programs/final",
          element: <LayoutContent element={CreateProgramPage} />,
        },
        {
          path: "fitness/programs/:id",
          element: <LayoutContent element={EditProgramPage} />,
        },
        {
          path: "fitness/programs/final/:id",
          element: <LayoutContent element={CreateProgramPage} />,
        },
        {
          path: "fitness/sessions",
          element: <LayoutContent element={SessionList} />,
        },
        {
          path: "fitness/sessions/:id",
          element: <LayoutContent element={CreateSession} />,
        },
        {
          path: "fitness/sessions/create",
          element: <LayoutContent element={CreateSession} />,
        },
        {
          path: "/",
          element: <LayoutContent element={Welcome} />,
        },
        {
          path: "/clients",
          element: <LayoutContent element={MyClientsList} />,
        },
        {
          path: "/clients/:id",
          element: <LayoutContent element={ClientDetails} />,
        },
        {
          path: "/coaches",
          element: <LayoutContent element={CoachesList} />,
        },
        {
          path: "/settings",
          element: <LayoutContent element={Settings} />,
        },
        {
          path: "admin/clients",
          element: <LayoutContent element={MyAdminClientsList} />,
        },
        {
          path: "admin/owners/:orgId",
          element: <LayoutContent element={OwnerDetail} />,
        },
        {
          path: "/tutoriels",
          element: <LayoutContent element={TutorialsPage} />,
        },
        {
          path: "/ressources/personnalisation",
          element: <LayoutContent element={PersonalizationPage} />,
        },
      ],
    },
    {
      path: "/onboarding",
      element: (
        <ProtectedRoute>
          <OnboardingPage />
        </ProtectedRoute>
      ),
    },
    { path: "/login", element: <AuthPage /> },
    { path: "/forget-password", element: <AuthPage /> },
    { path: "/signup", element: <AuthPage /> },
    { path: "*", element: <Navigate to="/login" /> },
  ];
  return useRoutes(routes);
};

export default Routes;
